import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    title: {
      namespaced: true,
      state: {
        pageTitle: 'マイページ',
      },
      actions: {
        changePage({commit}, title) {
          commit('changeTitle', title);
        },
      },
      mutations: {
        changeTitle(state, title) {
          state.pageTitle = title;
        },
      },
      getters: {
        pageTitle(state) {
          return state.pageTitle;
        },
      },
    },
    status: {
      namespaced: true,
      state: {
        isPublic: true,
        isSidebarHidden: true,
      },
      actions: {
        changePage({commit}, isPublic) {
          commit('changePage', isPublic);
        },
        changeSidebar({commit}, isSidebarHidden) {
          commit('changeSidebar', isSidebarHidden);
        },
      },
      mutations: {
        changePage(state, isPublic) {
          state.isPublic = isPublic;
        },
        changeSidebar(state, isSidebarHidden) {
          state.isSidebarHidden = isSidebarHidden;
        },
      },
      getters: {
        isPublic(state) {
          return state.isPublic;
        },
        isSidebarHidden(state) {
          return state.isSidebarHidden;
        },
      },
    },
    users:{
      namespaced: true,
      state: {
        progress: 'display',
      },
      actions: {
        pushProgress({commit}, progress) {
          commit('changeProgress', progress);
        },
      },
      mutations: {
        changeProgress(state, progress) {
          state.progress = progress;
        },
      },
      getters: {
        progress(state) {
          return state.progress;
        },
      },
    },
    statement:{
      namespaced: true,
      state: {
        progress: 'display',
      },
      actions: {
        pushProgress({commit}, progress) {
          commit('changeProgress', progress);
        },
      },
      mutations: {
        changeProgress(state, progress) {
          state.progress = progress;
        },
      },
      getters: {
        progress(state) {
          return state.progress;
        },
      },
    },
    billing:{
      namespaced: true,
      state: {
        progress: 'display',
      },
      actions: {
        pushProgress({commit}, progress) {
          commit('changeProgress', progress);
        },
      },
      mutations: {
        changeProgress(state, progress) {
          state.progress = progress;
        },
      },
      getters: {
        progress(state) {
          return state.progress;
        },
      },
    },
    billingInfo:{
      namespaced: true,
      state: {
        progress: 'display',
      },
      actions: {
        pushProgress({commit}, progress) {
          commit('changeProgress', progress);
        },
      },
      mutations: {
        changeProgress(state, progress) {
          state.progress = progress;
        },
      },
      getters: {
        progress(state) {
          return state.progress;
        },
      },
    },
    changePassword:{
      namespaced: true,
      state: {
        progress: 'input',
      },
      actions: {
        pushProgress({commit}, progress) {
          commit('changeProgress', progress);
        },
      },
      mutations: {
        changeProgress(state, progress) {
          state.progress = progress;
        },
      },
      getters: {
        progress(state) {
          return state.progress;
        },
      },
    },
    forgotPassword: {
      namespaced: true,
      state: {
        progress: 'input',
      },
      actions: {
        pushProgress({commit}, progress) {
          commit('changeProgress', progress);
        },
      },
      mutations: {
        changeProgress(state, progress) {
          state.progress = progress;
        },
      },
      getters: {
        progress(state) {
          return state.progress;
        },
      },
    },
    changeCredit:{
      namespaced: true,
      state: {
        progress: 'input',
      },
      actions: {
        pushProgress({commit}, progress) {
          commit('changeProgress', progress);
        },
      },
      mutations: {
        changeProgress(state, progress) {
          state.progress = progress;
        },
      },
      getters: {
        progress(state) {
          return state.progress;
        },
      },
    },
    outstanding:{
      namespaced: true,
      state: {
        progress: 'input',
      },
      actions: {
        pushProgress({commit}, progress) {
          commit('changeProgress', progress);
        },
      },
      mutations: {
        changeProgress(state, progress) {
          state.progress = progress;
        },
      },
      getters: {
        progress(state) {
          return state.progress;
        },
      },
    }
  }
})
